import React, { Component } from "react";
import { connect } from "react-redux";
import { GET_LISTDATA } from "../../actions";
import Select from "react-select";
import Swal from "sweetalert2";
import $ from "jquery";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { adminlimit, apiUrl, downloadUrl, s3Link } from "../Settings/Config";
import api from "../../utils/axios";
import { showContaimerLoader, encodeValue, removeItem, showPageCount, showDate, showLoader, hideLoader, showAlert, showDBDate, hasPermission, addModule, showHTMLText } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
const module = "purchaseorder";
const modulePath = "/purchaseorder";
const moduleName = "Purchase Order";
const dropDownlist = [
  { label: "PO Type", key: "spomtype", optionList: "spomtypeList" },
  { label: "Branch", key: "branch", optionList: "branchList" },
  { label: " PO Raised By", key: "potype", optionList: "potypeList" },
  { label: "Vessel", key: "POvessel", optionList: "vessleList" },
  { label: "Company", key: "POCompany", optionList: "companyList" },
  { label: "Vendor", key: "vendor", optionList: "vendorList" },
  { label: "By User", key: "user", optionList: "userList" },
  { label: "Status", key: "approveStatus", optionList: "statusList" },
];
const moduleID = 16;
class List extends Component {
   closeBtnRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      pageLimit: { label: adminlimit, value: adminlimit },
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      searchpo_number: "",
      spomtype: "",
      branch: "",
      potype: "",
      POvessel: "",
      POCompany: "",
      vendor: "",
      user: "",
      approveStatus: "",
      po_from_date: "",
      po_to_date: "",
      spomtypeList: [
        { label: "Vessel", value: "Vessel" },
        { label: "Office Expenses", value: "Office Expenses" },
      ],
      potypeList: [
        { label: "Nautilus", value: "Nautilus" },
        { label: "Owners", value: "Ownerss" },
      ],
      branchList: [],
      vessleList: [],
      companyList: [],
      vendorList: [],
      userList: [],
      statusList: [
        { label: "Pending", value: "0" },
        { label: "Approved", value: "1" },
        { label: "Rejected", value: "2" },
      ],
      PODetails: "",
      poItem: [],
      candidateList: [],
      poAmount: "",
      poNumber: "",
      uploadPOID: "",
      poInvoiceNumber: "",
      poInvoiceAmount: "",
      poInvoiceRemarks: "",
      poInvoiceNumberError: "",
      poInvoiceAmountError: "",
      poInvoiceRemarksError: "",
      poInvoiceError: "",
      viewpopupFile: "",
      viewFileTitle: "",
      showExport: false,
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    if (!hasPermission(moduleID, "view")) {
      this.props.history.push("/search");
    } else {
      this.loadList(1);
      this.loadDropdown();
    }
  }
  closeModal = () => {
    this.closeBtnRef.current.click();
  };


  loadDropdown() {
    api
      .get("branch/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ branchList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("vessel/alldropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          let finalVessel = [];
          result.forEach((vessel) => {
            if (vessel.vesselCode !== "" && vessel.vesselCode !== null) {
              finalVessel.push(vessel);
            }
          });
          this.setState({ vessleList: finalVessel });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("company/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          this.setState({ companyList: result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("povendor/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          this.setState({ vendorList: result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("purchaseorder/getUserList")
      .then((res) => {
        if (res.data.success === true) {
          const result = res.data.result;
          this.setState({ userList: result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      let showExport = true;
      if (nextProps.totalRecords === 0) {
        showExport = false;
      }
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
        showExport,
      });
    }
  }
  searchList(e) {
    e.preventDefault();
    this.setState({ loading: true, currentPage: 1 }, () => {
      this.loadList(1);
    });
  }
  resetSearch(e) {
    e.preventDefault();
    this.setState(
      {
        loading: true,
        searchpo_number: "",
        spomtype: "",
        branch: "",
        potype: "",
        POvessel: "",
        POCompany: "",
        vendor: "",
        user: "",
        approveStatus: "",
        po_from_date: "",
        po_to_date: "",
        currentPage: 1,
      },
      () => {
        this.loadList(1);
      },
    );
  }
  loadList = async (offset, exportExcel = false) => {
    let addParams = "";
    if (this.state.searchpo_number !== "") {
      addParams += `&searchpo_number=${this.state.searchpo_number}`;
    }
    if (this.state.spomtype !== null && Object.keys(this.state.spomtype).length > 0) {
      addParams += `&spomtype=${this.state.spomtype.value}`;
    }
    if (this.state.branch !== null && Object.keys(this.state.branch).length > 0) {
      addParams += `&branch=${this.state.branch.value}`;
    }
    if (this.state.potype !== null && Object.keys(this.state.potype).length > 0) {
      addParams += `&potype=${this.state.potype.value}`;
    }
    if (this.state.POvessel !== null && Object.keys(this.state.POvessel).length > 0) {
      addParams += `&POvessel=${this.state.POvessel.value}`;
    }
    if (this.state.POCompany !== null && Object.keys(this.state.POCompany).length > 0) {
      addParams += `&POCompany=${this.state.POCompany.value}`;
    }
    if (this.state.vendor !== null && Object.keys(this.state.vendor).length > 0) {
      addParams += `&vendor=${this.state.vendor.value}`;
    }
    if (this.state.POCompany !== null && Object.keys(this.state.POCompany).length > 0) {
      addParams += `&POCompany=${this.state.POCompany.value}`;
    }
    if (this.state.user !== null && Object.keys(this.state.user).length > 0) {
      addParams += `&user=${this.state.user.value}`;
    }
    if (this.state.approveStatus !== null && Object.keys(this.state.approveStatus).length > 0) {
      addParams += `&approveStatus=${this.state.approveStatus.value}`;
    }
    if (this.state.po_from_date !== "") {
      addParams += `&fromDate=${showDBDate(this.state.po_from_date)}`;
    }
    if (this.state.po_to_date !== "") {
      addParams += `&toDate=${showDBDate(this.state.po_to_date)}`;
    }

    if (exportExcel) {
      showLoader("exportExcel");
      const response = await axios.get(`${apiUrl}${module}/expxortPO?${addParams}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        responseType: "blob",
      });
      hideLoader("exportExcel");
      // Create a download link
      const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "purchase-order.xlsx"); // ✅ File name
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      this.setState({ loading: true });
      const params = {
        params: "limit=" + this.state.pageLimit.value + "&offset=" + offset + addParams,
        url: `${module}`,
      };
      this.props.getListData(params);
    }
  };
  edit(editID, e) {
    e.preventDefault();
    this.props.history.push({
      pathname: `${modulePath}/edit`,
      state: { editID: encodeValue(editID) },
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      /* if (this.state.currentPage !== value) { */
        this.setState(
          {
            loading: true,
            currentPage: value,
          },
          () => {
            this.loadList(value);
          },
        );
      /* } */
    } else if (field === "pageLimit") {
      this.setState({ pageLimit: value, currentPage: 1 }, () => {
        this.loadList(1);
      });
    }
  };
  handleChangeText(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value, [`${name}Error`]: "" });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, this.sateValChange, this.state.currentPage);
  }
  viewPODetails(poID) {
    api
      .get(`${module}/getpodetail/${poID}`)
      .then((res) => {
        if (res.data.success === true) {
          this.setState({ PODetails: res.data.result, poItem: res.data.poItem, candidateList: res.data.candidateList }, () => {
            $("#viewPODetails").trigger("click");
          });
        }
      })
      .catch((err) => {
        this.setState({ PODetails: "" });
        console.error(err);
      });
  }
  approvePO = (approveType) => {
  const approveTypeTxt = approveType === 1 ? "Approve" : "Reject";
  const poID = this.state.PODetails.poID;

  Swal.fire({
    title: "Are you sure?",
    text: `You want ${approveTypeTxt} this item!`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: `Yes, ${approveTypeTxt} it!`,
    showLoaderOnConfirm: true,
    preConfirm: async () => {
      try {
        const res = await api.post(`${module}/approvePO`, {
          poID,
          approveType,
        });

        return res.data;
      } catch (e) {
        return e?.response?.data || {
          success: false,
          message: e.message,
        };
      }
    },
  }).then((result) => {
    if (result.isConfirmed && result.value) {
      Swal.fire({
        icon: result.value.success ? "success" : "error",
        title: result.value.success ? approveTypeTxt : "Alert",
        text: result.value.message,
      }).then(() => {
        if (result.value.success) {
          this.loadList(this.state.currentPage);
          this.closeModal()
        }
      });
    }
  });
};
  generatePO = async (poID, e) => {
    e.preventDefault();
    showLoader(`po-details${poID}`);
    try {
      const response = await axios.get(`${apiUrl}${module}/generatePO?poID=${poID}`, { headers: { Authorization: localStorage.getItem("token") } });
      const fileName = response.data.fileName;
      if (fileName !== "" && fileName !== null) {
        const fileUrl = `${downloadUrl}po/${fileName}`;
        // Create a temporary link and trigger download immediately
        const a = document.createElement("a");
        a.href = fileUrl;
        a.target = "_blank";
        a.download = fileName; // optional dynamic filename
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
      hideLoader(`po-details${poID}`);
    } catch (e) {
      hideLoader(`po-details${poID}`);
      console.error("Error:", e);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Faild to download",
      });
    }
  };
  uploadInvoice = async (poID, poInvoiceAmount, poNumber, e) => {
    e.preventDefault();
    this.setState({ poAmount: poInvoiceAmount, poNumber: poNumber, uploadPOID: poID });
    $("#uploadInvoice").trigger("click");
  };
  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      this.setState({ viewpopupFile: previewUrl, poInvoiceError: "" });
    }
  };
  viewFile(viewpopupFile, viewFileTitle, e) {
    e.preventDefault();
    this.setState({ viewpopupFile, viewFileTitle }, () => {
      $("#viewFileDetails").trigger("click");
    });
  }
  updateInvoice = (e) => {
    e.preventDefault();

    const poInvoiceAmount = this.state.poInvoiceAmount;
    const poInvoiceNumber = this.state.poInvoiceNumber;
    const poInvoiceRemarks = this.state.poInvoiceRemarks;
    let error = 0;
    if (poInvoiceNumber === "") {
      this.setState({ poInvoiceNumberError: "This field is required" });
      error++;
    } else {
      this.setState({ poInvoiceNumberError: "" });
    }
    if (poInvoiceAmount === "") {
      this.setState({ poInvoiceAmountError: "This field is required" });
      error++;
    } else {
      this.setState({ poInvoiceAmountError: "" });
      const poAmount_ = parseFloat(this.state.poAmount).toFixed(2);
      if (poAmount_ !== parseFloat(poInvoiceAmount).toFixed() && poInvoiceRemarks === "") {
        error++;
        this.setState({ poInvoiceRemarksError: "This field is required" });
      } else {
        this.setState({ poInvoiceRemarksError: "" });
      }
    }

    const fileInput = document.getElementById("poInvoice");
    const file = fileInput?.files?.[0];
    if (file) {
      if (file.type !== "application/pdf") {
        error++;
        this.setState({ poInvoiceError: "Document PDF only allowed" });
      } else {
        this.setState({ poInvoiceError: "" });
      }
    } else {
      this.setState({ poInvoiceError: "This field is required" });
      error++;
    }

    if (error === 0) {
      showLoader("updateInvoiceBtn");
      const postObject = {
        poID: this.state.uploadPOID,
        InvoiceAmount: this.state.poInvoiceAmount,
        InvoiceNumber: this.state.poInvoiceNumber.toUpperCase(),
        InvoiceRemarks: this.state.poInvoiceRemarks.toUpperCase(),
      };

      const formPayload = new FormData();
      if (file) {
        if (file.type === "application/pdf") {
          formPayload.append("invoice", file);
        }
      }

      Object.keys(postObject).forEach((key) => {
        formPayload.append(key, postObject[key]);
      });

      const post_url = `${module}/uploadPoInvoice`;

      api
        .post(post_url, formPayload)
        .then((res) => {
          hideLoader("updateInvoiceBtn");
          $(".btn-close").trigger("click");
          const errMsg = res.data.message;
          if (res.data.success === true) {
            showAlert("Success", errMsg, "success", "No");
            this.loadList(this.state.currentPage);
          }
        })
        .catch((err) => {
          hideLoader("updateInvoiceBtn");
          const errMsg = err.response.data?.message || err?.message;
          showAlert("Error", errMsg, "error", "No");
          console.error(err);
        });
    }
  };
  closePopup = (e) => {
    e.preventDefault();
    this.setState({ poAmount: "", poNumber: "", uploadPOID: "", poInvoiceNumber: "", poInvoiceAmount: "", poInvoiceRemarks: "", viewpopupFile: "", viewFileTitle: "" }, () => {
    });
  };

  invoiceRaised(poID, poInvoiceRaised, e) {
    if (poInvoiceRaised === 0) {
      Swal.fire({
        title: "Are you sure?",
        text: `You want confirm Invoice Raised this item!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Yes, Confirm it!`,
        customClass: {
          confirmButton: "btn btn-primary me-3 waves-effect waves-light",
          cancelButton: "btn btn-label-secondary waves-effect",
        },
        buttonsStyling: false,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          try {
            const poDatas = {
              poID,
            };
            return api
              .post(`${module}/raiseInvoice`, poDatas)
              .then((res) => {
                return res.data;
              })
              .catch((e) => {
                console.log(e);
                return e?.response?.data ?? { success: false, message: e.message };
              });
          } catch (err) {
            console.log(err);
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        const value = result?.value ?? "";
        if (value !== "") {
          if (result.value.success === true) {
            Swal.fire({
              icon: "success",
              title: `Invoice Raised!`,
              text: result.value.message,
              customClass: {
                confirmButton: "btn btn-success waves-effect",
              },
            }).then(() => {
              this.loadList(this.state.currentPage);
            });
          } else {
            Swal.fire({
              title: "Alert",
              text: result.value.message,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-danger waves-effect",
              },
            });
          }
        }
      });
    }
  }

  render() {
    const nemouserId = localStorage.getItem("nemouserId") || "";
    const PODetails = this.state.PODetails;
    const poItem = this.state.poItem;
    const candidateList = this.state.candidateList;

    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid mx-3">
                  {addModule(moduleID, moduleName, modulePath)}
                  <button className="hidden" type="button" data-bs-toggle="modal" data-bs-target="#extralargemodal" data-backdrop="static" data-keyboard="false" id="viewPODetails">
                    &nbsp
                  </button>
                  <button className="hidden" type="button" data-bs-toggle="modal" data-bs-target="#uploadInvoicemodal" data-backdrop="static" data-keyboard="false" id="uploadInvoice">
                    &nbsp
                  </button>
                  <button className="hidden" type="button" data-bs-toggle="modal" data-bs-target="#viewFilemodal" data-backdrop="static" data-keyboard="false" id="viewFileDetails">
                    &nbsp
                  </button>
                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            <div className="col-md-3">
                              <label className="form-label">Search PO Number</label>
                              <input type="text" className="form-control" placeholder={"Search PO Number"} name="searchpo_number" onChange={this.handleChangeText} value={this.state.searchpo_number} />
                            </div>
                            {dropDownlist.map((item, index) => {
                              return (
                                <div className="col-md-3" key={index}>
                                  <label className="form-label">{item.label}</label>
                                  <Select
                                    value={this.state[`${item.key}`]}
                                    onChange={this.handleSelectChange.bind(this, item.key)}
                                    placeholder={`Select ${item.label}`}
                                    isClearable={true}
                                    options={this.state[`${item.optionList}`]}
                                  />
                                </div>
                              );
                            })}
                            <div className="form-group col-md-3">
                              <label className="form-label">PO Form Date</label>
                              <DatePicker
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                placeholderText="Select PO Form Date"
                                className="form-control"
                                onKeyDown={(e) => e.preventDefault()}
                                selected={this.state.po_from_date}
                                dateFormat="dd-MM-yyyy"
                                isClearable={this.state.po_from_date ? true : false}
                                onChange={this.handleSelectChange.bind(this, "po_from_date")}
                              />
                            </div>
                            <div className="form-group col-md-3">
                              <label className="form-label">PO To Date</label>
                              <DatePicker
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                placeholderText="Select PO To Date"
                                className="form-control"
                                onKeyDown={(e) => e.preventDefault()}
                                selected={this.state.po_to_date}
                                dateFormat="dd-MM-yyyy"
                                isClearable={this.state.po_to_date ? true : false}
                                minDate={this.state.po_from_date !== "" ? this.state.po_from_date : ""}
                                onChange={this.handleSelectChange.bind(this, "po_to_date")}
                              />
                            </div>

                            <div className="col-md-2">
                              <div className="mt-6">
                                <a href="/" className="btn btn-primary" onClick={this.searchList.bind(this)}>
                                  Search
                                </a>
                                <a href="/" className="btn btn-secondary offset-1" onClick={this.resetSearch.bind(this)}>
                                  Reload
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        {this.state.showExport && (
                          <div className="card-header">
                            <div className="card-options">
                              <button type="button" className="btn btn-success" id="exportExcel" onClick={this.loadList.bind(this, 1, true)}>
                                Export
                              </button>
                            </div>
                          </div>
                        )}
                        <div>
                          <div className="card-header">
                            {parseInt(this.state.totalPage) > 0 &&
                              showPageCount(moduleName, this.state.currentPage, this.state.totalPage, this.state.totalRecords, this.sateValChange, this.state.pageLimit)}
                          </div>
                          <div className="card-body">
                            <div className="table-responsive">
                              <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                <thead className="table-primary">
                                  <tr>
                                    {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && <th className="text-center">Actions</th>}
                                    <th>S.No.</th>
                                    <th>PO Number</th>
                                    <th>PO Date</th>
                                    <th>Status</th>
                                    <th>PO Type</th>
                                    <th>PO Raised By</th>                                    
                                    <th>Vendor</th>
                                    <th>Vessel</th>
                                    <th>Company</th>
                                    <th>Total Amount</th>
                                    <th>PO</th>
                                    <th>Invoice</th>
                                    <th>Invoice Number</th>
                                    <th>Invoice Amount</th>
                                    <th>Invoice Remarks</th>
                                    <th>Invoice Raised</th>
                                    <th>PO Created By</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.loading ? (
                                    <tr>
                                      <td colSpan={17}>{showContaimerLoader()}</td>
                                    </tr>
                                  ) : this.state.listdata.length > 0 ? (
                                    this.state.listdata.map((item, index) => {
                                      return (
                                        <tr key={index}>
                                          {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && (
                                            <td className="text-center text-nowrap" valign="top">
                                              {hasPermission(moduleID, "delete") && (
                                                <a href="/" className="delete_record" onClick={this.removeItem.bind(this, encodeValue(item.poID))}>
                                                  <i className="fa fa-trash"></i>
                                                </a>
                                              )}
                                            </td>
                                          )}
                                          <td>{(parseInt(this.state.currentPage) - 1) * parseInt(this.state.pageLimit.value) + (parseInt(index) + 1)}</td>
                                          <td>{item.poNumber}</td>
                                          <td>{showDate(item.poDate)}</td>
                                          <td>
                                            {(() => {
                                              if (["1", "5", "87", "227", "247", "27", "236", "251", "177", "167"].indexOf(nemouserId.toString()) >= 0 && item.poApproveStatus === 0) {
                                                return (
                                                  <button type="button" className="btn btn-warning" onClick={this.viewPODetails.bind(this, item.poID)}>
                                                    Pending
                                                  </button>
                                                );
                                              } else {
                                                let btnName = "";
                                                if (item.poApproveStatus === 0) {
                                                  btnName = "warning";
                                                } else if (item.poApproveStatus === 1) {
                                                  btnName = "success";
                                                } else if (item.poApproveStatus === 2) {
                                                  btnName = "danger";
                                                }
                                                return (
                                                  <button type="button" className={`btn btn-${btnName}`} onClick={this.viewPODetails.bind(this, item.poID)}>
                                                    {(() => {
                                                      if (item.poApproveStatus === 0) {
                                                        return "Pending";
                                                      } else if (item.poApproveStatus === 1) {
                                                        return "Approved";
                                                      } else if (item.poApproveStatus === 2) {
                                                        return "Rejected";
                                                      }
                                                    })()}
                                                  </button>
                                                );
                                              }
                                            })()}
                                          </td>
                                          <td>{item.poMType}</td>
                                          <td>{item.poType}</td>
                                          <td>{item.vendorName}</td>
                                          <td>{item.vesselName}</td>
                                          <td>{item.company_name}</td>
                                          <th>
                                            {item.poCurrency} {item.poGrandTotal}
                                          </th>
                                          <td className="text-center text-nowrap" id={`po-details${item.poID}`}>
                                            <a href="/" onClick={this.generatePO.bind(this, item.poID)}>
                                              <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                            </a>
                                          </td>
                                          <td className="text-center text-nowrap">
                                            {item.poApproveStatus === 1 &&
                                              (item.poInvoice !== "" && item.poInvoice !== null ? (
                                                <a href="/" onClick={this.viewFile.bind(this, `${downloadUrl}uploads/poinvoice/${item.poInvoice}`, "Invoice")}>
                                                  <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                                </a>
                                              ) : (
                                                <a href="/" onClick={this.uploadInvoice.bind(this, item.poID, item.poGrandTotal || 0, item.poNumber)}>
                                                  <i className="fa fa-upload" aria-hidden="true"></i>
                                                </a>
                                              ))}
                                          </td>
                                          <td>{item.poInvoiceNumber}</td>
                                          <td>
                                            {item.poCurrency}
                                            {item.poInvoiceAmount || 0}
                                          </td>
                                          <td>{item.poInvoiceRemarks}</td>

                                          <td>
                                            <div className="text-center">
                                              {item.poApproveStatus === 1 && item.poInvoice !== "" && item.poInvoice !== null ? (
                                                <div className="custom-controls-stacked">
                                                  <label className="custom-control custom-checkbox-md">
                                                    <input
                                                      type="checkbox"
                                                      className="custom-control-input"
                                                      name="example-checkbox5"
                                                      checked={item.poInvoiceRaised === 1 ? true : false}
                                                      onChange={this.invoiceRaised.bind(this, item.poID, item.poInvoiceRaised)}
                                                    />
                                                    <span className="custom-control-label">&nbsp;</span>
                                                  </label>
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          </td>
                                          <td>{item.userName}</td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr>
                                      <td className="text-center" colSpan={15}>
                                        No {moduleName} Found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                            {parseInt(this.state.totalPage) > 1 && (
                              <Pagenation
                                params={{
                                  totalRecords: this.state.totalRecords,
                                  totalPage: this.state.totalPage,
                                  currentPage: this.state.currentPage,
                                }}
                                sateValChange={this.sateValChange}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="extralargemodal" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  View Details <b>{PODetails?.poNumber || ""}</b>
                </h5>
                <button ref={this.closeBtnRef} className="btn-close" data-bs-dismiss="modal" aria-label="Close"/*  onClick={this.closePopup.bind(this)} */>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                {PODetails !== "" && (
                  <div>
                    <table>
                      <tbody>
                      <tr>
                        <td>PO Type</td>
                        <td>:</td>
                        <td>{PODetails.poMType}</td>
                      </tr>
                      <tr>
                        <td>Branch</td>
                        <td>:</td>
                        <td>{PODetails.branchName}</td>
                      </tr>
                      <tr>
                        <td>PO RAISED BY</td>
                        <td>:</td>
                        <td>{PODetails.poType}</td>
                      </tr>
                      <tr>
                        <td>Vessel</td>
                        <td>:</td>
                        <td>{PODetails?.vesselName || "-"}</td>
                      </tr>
                      <tr>
                        <td>Vendor</td>
                        <td>:</td>
                        <td>{PODetails.vendorName}</td>
                      </tr>
                      <tr>
                        <td>PO Date</td>
                        <td>:</td>
                        <td>{showDate(PODetails.poDate)}</td>
                      </tr>
                      <tr>
                        <td>Vendor Ref.</td>
                        <td>:</td>                        
                        <td>{PODetails.poVesselRef}</td>
                      </tr>
                      <tr>
                        <td>Currency</td>
                        <td>:</td>
                        <td>{PODetails.poCurrency}</td>
                      </tr>
                      </tbody>
                    </table>
                    <br />
                    <table className="po-item">
                      <thead>
                        <tr>
                          <th>S. No</th>
                          {PODetails.poMType === "Vessel" ? <th className="for-vessel">Category</th> : ""}
                          <th>Description</th>
                          <th>Qty</th>
                          <th>Unit</th>
                          <th>Rate</th>
                          <th>Tax(%)</th>
                          <th>Tax Amount</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {poItem.length > 0
                          ? poItem.map((item, index) => {
                              let finalCandidate = "";
                              if (PODetails.poMType === "Vessel") {
                                const poItemCandidateID = item.poItemCandidateID !== "" && item.poItemCandidateID !== null ? item.poItemCandidateID.split(",") : [];
                                finalCandidate =
                                  poItemCandidateID.length > 0
                                    ? poItemCandidateID
                                        .map((id) => {
                                          const cand = candidateList.find((c) => c.candidateId === Number(id));
                                          return cand ? `${cand.candidateId} - ${cand.name} - ${cand.c_rank}` : null;
                                        })
                                        .filter(Boolean) // remove nulls if any id not found
                                        .join("<br/>")
                                    : "";
                              } else {
                                finalCandidate = item.poItemDescription;
                              }

                              return (
                                <tr key={index}>
                                  <td valign="top" className="center-align">
                                    {parseInt(index) + 1}
                                  </td>
                                  {PODetails.poMType === "Vessel" ? <td valign="top">${item.categoryName}</td> : ``}
                                  <td>{showHTMLText(finalCandidate)}</td>
                                  <td valign="top">{item.poItemQuantity}</td>
                                  <td valign="top">{item.poItemUnit}</td>
                                  <td valign="top" className="right-align">
                                    {PODetails.poCurrency} {item.poItemRate}
                                  </td>
                                  <td valign="top">{item?.poGSTValue || ""}</td>
                                  <td valign="top" className="right-align">
                                    {parseFloat(item.poGSTAmount) > 0 ? `${PODetails.poCurrency} ${item.poGSTAmount}` : ""}
                                  </td>
                                  <td valign="top" className="right-align">
                                    {PODetails.poCurrency} {item.poItemTotalRate}
                                  </td>
                                </tr>
                              );
                            })
                          : ""}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan={PODetails.poMType === "Vessel" ? "8" : "7"} className="right-align total-cells">
                            <b>Total</b>
                          </td>
                          <td className="right-align" id="subTotal">
                            {PODetails.poCurrency} {PODetails.posubTotal}
                          </td>
                        </tr>
                        {PODetails.poNote && (
                          <tr>
                            <td colSpan={PODetails.poMType === "Vessel" ? "9" : "8"} className="right-align">
                              <b>Note</b>
                              {PODetails.poNote}
                            </td>
                          </tr>
                        )}
                        {parseFloat(PODetails.poLessDiscount) > 0 ? (
                          <tr>
                            <td colSpan={PODetails.poMType === "Vessel" ? "8" : "7"} className="right-align total-cell">
                              <b>Less discount(-)</b>
                            </td>
                            <td className="right-align">
                              {PODetails.poCurrency} {PODetails.poLessDiscount}
                            </td>
                          </tr>
                        ) : (
                          ``
                        )}
                        {parseFloat(PODetails.poInsuranceAmount) > 0 ? (
                          <tr>
                            <td colSpan={PODetails.poMType === "Vessel" ? "8" : "7"} className="right-align total-cell">
                              <b>Add Insurance</b>
                            </td>
                            <td className="right-align">
                              {PODetails.poCurrency} {PODetails.poInsuranceAmount}
                            </td>
                          </tr>
                        ) : (
                          ``
                        )}
                        {parseFloat(PODetails.poDelCharges) > 0 ? (
                          <tr>
                            <td colSpan={PODetails.poMType === "Vessel" ? "8" : "7"} className="right-align total-cell">
                              <b>Add Del.Charges</b>
                            </td>
                            <td className="right-align">
                              {PODetails.poCurrency} {PODetails.poDelCharges}
                            </td>
                          </tr>
                        ) : (
                          ``
                        )}
                        {parseFloat(PODetails.poOtherAmount) > 0 ? (
                          <tr>
                            <td colSpan={PODetails.poMType === "Vessel" ? "8" : "7"} className="right-align total-cell">
                              <b>Other</b>
                            </td>
                            <td className="right-align">
                              {PODetails.poCurrency} {PODetails.poOtherAmount}
                            </td>
                          </tr>
                        ) : (
                          ``
                        )}
                        <tr>
                          <td colSpan={PODetails.poMType === "Vessel" ? "8" : "7"} className="right-align total-cell">
                            <b>Total Amount</b>
                          </td>
                          <td className="right-align">
                            {PODetails.poCurrency} {PODetails.poGrandTotal}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                )}
              </div>
              {PODetails !== "" && PODetails?.poApproveStatus === 0 && ["1", "5", "87", "227", "247", "27", "236", "251", "177", "167"].indexOf(nemouserId.toString()) >= 0 && (
                <div className="modal-footer">
                  <button className="btn btn-primary"  onClick={this.approvePO.bind(this, 1)}>
                    Approve PO
                  </button>{" "}
                  <button className="btn btn-danger" onClick={this.approvePO.bind(this, 2)}>
                    Reject
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="modal fade" id="uploadInvoicemodal" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Upload Invoice - PO Number: {this.state.poNumber}, PO Amount: <b>{this.state.poAmount}</b>
                </h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close" /* onClick={this.closePopup.bind(this)} */>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <div className="form-row">
                    <div className="form-group col-md-4">
                      <div className="form-group">
                        <label className="form-label">Invoice File</label>
                        <div className="input-group">
                          <input className="form-control" type="file" name="poInvoice" id="poInvoice" accept="application/pdf" onChange={this.handleFileChange} />
                          {this.state.viewpopupFile !== "" && (
                            <a href="/" onClick={this.viewFile.bind(this, this.state.viewpopupFile)}>
                              <span className="input-group-text btn btn-secondary shadow-none" title="View Document" style={{ margin: 0, height: "100%" }}>
                                <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                              </span>
                            </a>
                          )}
                          {this.state.poInvoiceError && <span className="error">{this.state.poInvoiceError}</span>}
                        </div>
                      </div>
                    </div>
                    <div className="form-group col-md-3">
                      <label className="form-label">
                        Invoice Number<span className="lbl-error">*</span>
                      </label>
                      <input type="text" className="form-control upper-case" placeholder="Invoice Number" name="poInvoiceNumber" value={this.state.poInvoiceNumber} onChange={this.handleChangeText} />
                      {this.state.poInvoiceNumberError && <span className="error">{this.state.poInvoiceNumberError}</span>}
                    </div>
                    <div className="form-group col-md-3">
                      <label className="form-label">
                        Invoice Amount<span className="lbl-error">*</span>
                      </label>
                      <input type="text" className="form-control upper-case" placeholder="Invoice Amount" name="poInvoiceAmount" value={this.state.poInvoiceAmount} onChange={this.handleChangeText} />
                      {this.state.poInvoiceAmountError && <span className="error">{this.state.poInvoiceAmountError}</span>}
                    </div>
                    <div className="form-group col-md-4">
                      <label className="form-label">Remarks</label>
                      <input type="text" className="form-control upper-case" placeholder="Remarks" name="poInvoiceRemarks" value={this.state.poInvoiceRemarks} onChange={this.handleChangeText} />
                      {this.state.poInvoiceRemarksError && <span className="error">{this.state.poInvoiceRemarksError}</span>}
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-danger">Close</button>{" "}
                <button className="btn btn-primary" id="updateInvoiceBtn" onClick={this.updateInvoice.bind(this)}>
                  Add Invoice
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="viewFilemodal" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{this.state.viewFileTitle}</h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              {this.state.viewpopupFile !== "" && (
                <div>
                  <iframe src={`${this.state.viewpopupFile}`} width="100%" height="500px" title="View Doc"></iframe>
                  <div className="modal-footer">
                    <button className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                      Close
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  let listdata = [];
  let totalPages = 0;
  let totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].success === true) {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
